import React from 'react';
import Post from '../components/post';
import LazyLoadImage from '../components/LazyLoadImage';


const CreditRepairPage = () => {
    const article = {
        id: '2a9dfea9-fa3b-5a5f-a3a3-103c20c745ec',
        title: 'Credit Repair: Everything You Need to Know',
        slug: '/credit-repair/',
        date: '2018-05-02T15:19:09.000Z',
        modified: '2021-11-04T19:00:14.000Z',
        excerpt: 'If you have bad credit, all is not lost. Credit repair and good financial habits can be very effective, helping you begin the climb toward an &#8220;Excellent&#8221; credit score. Learn how to do credit repair on your own, or consider working with a professional service.',
        featured_image: {
            source_url: '/media/credit-repair-guide.jpg',
        },
        acf: {
            seo_title: '',
            robots: 'index, follow',
        },
        read_time_minutes: 13,
        content: (
            <>
                <p>Many people wish they had better credit but don&rsquo;t know how to address the underlying problems that are dragging them down.</p>
                <p>We think that if we pay our bills on time, then our credit should be awesome.</p>
                <p>In reality, it&rsquo;s not that simple.</p>
                <p>Your credit standing is based on your past payment behaviors and how you manage all of the credit accounts that you juggle.</p>
                <p>Sometimes, though, there might be mistakes or old habits that are haunting you on your credit reports.</p>
                <p>
                    If you&rsquo;ve made missteps in the past,
                    {' '}
                    <a href="/credit-counseling/">mismanaged your debt</a>
                    , or are a victim of identity theft, some credit repair work might be necessary.
                </p>
                <p>A not-so-hot credit score puts limits on your borrowing power and could end up penalizing you.</p>
                <p>
                    It&rsquo;s tough to get approved for
                    {' '}
                    <a href="https://www.catrkr.com/rd/r.php?sid=864&pub=221062&c1=credit-repair&c2=loans" rel="noopener noreferrer" target="_blank">loans</a>
                    , mortgages,
                    {' '}
                    <a href="https://www.catrkr.com/rd/r.php?sid=864&pub=221062&c1=credit-repair&c2=credit-cards" rel="noopener noreferrer" target="_blank">credit cards</a>
                    , and other products when your credit is shot.
                </p>
                <p>
                    For those who do manage to qualify,
                    {' '}
                    <a href="https://www.creditloan.com/bad-credit-loans/" target="_blank" rel="noreferrer">a poor credit history</a>
                    {' '}
                    could mean paying higher interest rates, which translates to thousands of dollars wasted.
                </p>
                <p>The good news is that there are actionable steps you can take towards repairing your credit, either on your own or, in more serious cases, with the help of a third party.</p>
                <p>If you&rsquo;ve gone through bankruptcy, for instance, or been the victim of a serious identity theft, you may want to consider seeking professional help.</p>
                <p><LazyLoadImage alt="Data Showing U.S. Reported Cases of Identity Theft" src="/media/data-showing-u-s-reported-cases-of-identity-theft-1.png" /></p>
                <p>By going through the credit repair process step by step and giving your credit habits a makeover, you can correct errors, potentially remove negative items, and ultimately, see gradual improvements to your score.</p>
                <p>Even if you&rsquo;ve hit your low point or aren&rsquo;t sure how credit reports or credit scores work, it&rsquo;s never too late to get educated and start making strategic moves to rebuild.</p>
                <p>Credit repair can be very effective if done right, but it takes time and effort.</p>
                <p>Ready to get started?</p>
                <p>We put together a guide to credit repair below.</p>
                <p>Pick the strategies that will work best for your financial situation and embark on your credit repair mission.</p>
                <h2 id="what-is-credit-repair">What is Credit Repair?</h2>
                <h3>Credit repair can help you take charge of your personal finances</h3>
                <p>In simple terms, credit repair is the process of repairing a bad credit report to raise your credit scores.</p>
                <p>It&rsquo;s a good idea for any individual with a less-than-stellar credit history to be proactive and consider how repairing your credit can help put you on a better financial footing.</p>
                <p>
                    <strong>Yes, Virginia, you can rebuild your credit.</strong>
                    {' '}
                    The first step is realizing that credit reports and credit scores change all the time.
                </p>
                <p>Meaning, if you aren&rsquo;t pleased with where you stand now, it is in your power to make positive changes.</p>
                <p>
                    <strong>The ROI (return on investment) potential is high.</strong>
                    {' '}
                    Credit repair can help you limit some of the damaging items on your credit reports and, in turn, raise your credit score.
                </p>
                <p>
                    The higher your score goes, the more access you&rsquo;ll have to better financial products and lower interest rates (translation—big-time
                    {' '}
                    <a href="https://www.catrkr.com/rd/r.php?sid=864&pub=221062&c1=credit-repair&c2=savings" rel="noopener noreferrer" target="_blank">savings</a>
                    !).
                </p>
                <h3>You alone are the master of your credit-repair fate</h3>
                <p>No one is going to step out of the shadows and offer to fix your credit problems for you.</p>
                <p>That being said, it can be pretty empowering once you realize that credit repair is something within reach.</p>
                <p>Here&rsquo;s the best way to start:</p>
                <p>
                    <strong>Know where you stand.</strong>
                    {' '}
                    Do you even know why your credit isn&rsquo;t great?
                </p>
                <p>Start by pulling your credit reports and going through them with a fine-tooth comb (not literally!) to identify potential errors and questionable negative information and pinpoint your weaknesses.</p>
                <p>This is a step that can be done on your own annually — kind of how you do an annual health checkup — in order to keep tabs on your credit-wellness.</p>
                <p>Head to AnnualCreditReport.com to get your one free report from the three major credit reporting agencies: Experian, Equifax, and TransUnion.</p>
                <p>Credit reports are not the same as credit scores—they simply contain a summary of your past credit behaviors and your current account statutes.</p>
                <p>
                    A
                    {' '}
                    <em>credit score</em>
                    {' '}
                    is calculated based on the information contained in your credit reports.
                </p>
                <p>
                    <strong>Check the scoreboard.</strong>
                    {' '}
                    Once you&rsquo;ve reviewed your reports, you should also take it upon yourself to pull your credit score.
                </p>
                <p>There are many credit scores, but the most common one is your FICO Score, which ranges 300–850.</p>
                <p>
                    You might be able to get your credit score for free online—some
                    {' '}
                    <a href="https://www.catrkr.com/rd/r.php?sid=864&pub=221062&c1=credit-repair&c2=credit-card" rel="noopener noreferrer" target="_blank">credit card</a>
                    {' '}
                    companies offer it as a benefit.
                </p>
                <p>Or you can purchase it for around $15.</p>
                <h3>Don&rsquo;t let errors slide</h3>
                <p>If you find a mistake, your first order of business is to make things right.</p>
                <p>
                    <strong>First, it&rsquo;s free to do.</strong>
                    {' '}
                    The credit reporting agencies list your dispute options on their websites.
                </p>
                <p>You can notify them online, by phone, or via mail with dispute letters.</p>
                <p>Snail mail is a smart idea since it gives you a paper trail.</p>
                <p>If you find several errors and aren&rsquo;t sure how to proceed even after visiting the bureau websites, you might consider outside help.</p>
                <p>
                    <strong>An error-free report is your right.</strong>
                    {' '}
                    Yep, it&rsquo;s actually the law (the Fair Credit Reporting Act, to be exact) that the credit bureaus must investigate any dispute letters you file within 30 days (or 45 in some special instances).
                </p>
                <p>If it&rsquo;s proven that something is reported in error, it must be removed from your credit reports ASAP.</p>
                <h3>Figure out if credit repair can help you</h3>
                <p>Beyond blatant errors, there are other items on your credit reports that might need addressing.</p>
                <p>That&rsquo;s what credit repair is all about.</p>
                <p>Here are some key things to look out for:</p>
                <p>
                    <strong>You may spot accounts in your name that aren&rsquo;t yours.</strong>
                    {' '}
                    This could signal that your identity has been stolen, and those fraudulent accounts could be wreaking havoc on your score.
                </p>
                <p>
                    <strong>You can soothe old credit boo-boos.</strong>
                    {' '}
                    Past due accounts that are late, charged off, or have been sent to collections are wounds to your credit.
                </p>
                <p><LazyLoadImage alt="2017 Average Balance on Credit Cards" src="/media/2017-average-balance-on-credit-cards-2.png" /></p>
                <p>You must stop the bleeding.</p>
                <p>Although you can&rsquo;t remove these items completely (they remain for seven years), you can square things away and put your accounts back in good standing.</p>
                <h3>Decide between do-it-yourself credit repair or a guiding hand</h3>
                <p>In most cases, you can do-it-yourself (DIY) and repair credit on your own.</p>
                <p>However, for complex situations, such as a massive identity theft situation, it might benefit you to hire a credit repair company to do the time-consuming grunt work.</p>
                <p>Before you get started, keep these points in mind:</p>
                <p>
                    <strong>Patience is a credit repair virtue.</strong>
                    {' '}
                    How long it takes to repair your credit is unique to each person.
                </p>
                <p>Although the credit bureaus have to respond to your disputes within 30–45 days, some situations will result in some back and forth, and/or having to get on the phone with creditors.</p>
                <p>The speed at which you can successfully repair your credit depends on the reasons for your bad credit.</p>
                <p>
                    It will take longer to
                    {' '}
                    <a href="/bankruptcy/">recover after filing bankruptcy</a>
                    {' '}
                    (which stays on your report for 10 years), for instance, than it will if you just had a couple of late payments.
                </p>
                <p>
                    <strong>Proceed with caution if seeking help.</strong>
                    {' '}
                    Not all companies are reputable, especially in the credit repair industry.
                </p>
                <p>Good ones work on your behalf, and will not make any guarantees.</p>
                <p>Alarm bells should go off if anyone asks for money upfront.</p>
                <p>
                    <strong>Be on your best credit behavior moving forward.</strong>
                    {' '}
                    Credit repair is hard work, so make sure you&rsquo;re prepared for the long haul if necessary.
                </p>
                <p>
                    Make commitments to healthy credit habits so that you can build upon any improvements you make—starting
                    {' '}
                    <em>today!</em>
                </p>
                <p>Now that you&rsquo;ve done a deep dive into your credit, you can begin to do damage control.</p>
                <p>It&rsquo;s not an overnight process, but the sooner you get started, the sooner you can start seeing results.</p>
                <h2 id="calculating-your-credit-score">Calculating Your Credit Score</h2>
                <h3>Understand what goes into your score so you can work the system</h3>
                <p>So what&rsquo;s the deal with credit scores anyway?</p>
                <p>Before you go through the credit repair process, you should understand what your score means, and what you can expect in terms of incremental increases.</p>
                <p>Here&rsquo;s a calculation breakdown:</p>
                <p>
                    <strong>How good are you about paying your bills?</strong>
                    {' '}
                    Payment history is a big deal when it comes to FICO score, accounting for 35% of it.
                </p>
                <p>Scores drop once it&rsquo;s reported that you are more than 30 days late on a bill.</p>
                <p>The longer your bill goes unpaid (60 days, 90 days, etc.), the more damage it does to your score.</p>
                <p>On the flip side, consistent, on-time payments moving forward will help your score improve.</p>
                <p>
                    <strong>Do you carry balances?</strong>
                    {' '}
                    Accounting for 30% of your credit score, debt utilization (or how much of your available credit is being used) is important.
                </p>
                <p>If you have a $10,000 credit limit and you owe $9,000, that means you are utilizing 90% of your available credit.</p>
                <p>Your aim should be to stay below 30% and as close to zero as possible.</p>
                <p>
                    <strong>Don&rsquo;t ignore the remaining factors.</strong>
                    {' '}
                    There&rsquo;s a couple important ones that together can really take a bite out of your score if you&rsquo;re not mindful.
                </p>
                <p>Length of credit (the average age of your credit accounts), new credit (how many applications and lines made recently), and credit mix (the different types of accounts you have) comprise the remaining 35% of your score.</p>
                <p>In other words, closing old accounts or opening too many new ones in a short time span can be harmful to your credit.</p>
                <p>For younger consumers, a lack of credit can also limit your score.</p>
                <p>
                    If you only have one
                    {' '}
                    <a href="https://www.catrkr.com/rd/r.php?sid=864&pub=221062&c1=credit-repair&c2=credit-card" rel="noopener noreferrer" target="_blank">credit card</a>
                    {' '}
                    and you&rsquo;ve managed it poorly, part of your credit repair plan might be to add another line of credit and prove that you can handle yourself.
                </p>
                <h3>Where do scores come from?</h3>
                <p>Using the data collecting on your credit reports by the credit bureaus, different scoring models crunch the numbers to come up with a score.</p>
                <p>
                    <strong>Scores galore.</strong>
                    {' '}
                    It might surprise you to learn that there are hundreds of credit scores.
                </p>
                <p>The ones most people are familiar with are the three consumer scores that you can request, one for each of your credit reports.</p>
                <p>
                    <strong>FICO is king.</strong>
                    {' '}
                    FICO, which stands for Fair Isaac Corporation, is the credit score most frequently relied upon by lenders.
                </p>
                <p>However, there are other popular scoring models like VantageScore favored by the credit agency, TransUnion.</p>
                <p>Basically, each agency will have its own score that emulates the FICO score model.</p>
                <p>All of them work off of similar algorithms, assessing how creditworthy consumers are based on their behaviors.</p>
                <p>
                    <strong>Scores change constantly.</strong>
                    {' '}
                    Your score is a snapshot in time based on the most current information reported to the credit bureaus.
                </p>
                <p><LazyLoadImage alt="Americans' Opinions About Credit Bureaus" src="/media/americans-opinions-about-credit-bureaus-3.png" /></p>
                <p>While it&rsquo;s true that negative items like a late payment stay on your credit report for seven years, over time, the impact it has on your score diminishes.</p>
                <p>Say you miss a payment …</p>
                <p>The biggest impact will take place when that lateness is reported, and you&rsquo;ll likely see a big score drop right away.</p>
                <p>How much it drops will vary.</p>
                <p>The good news is your score will climb once you begin using credit responsibly.</p>
                <p>Your goal is to reach the &quot;Excellent&quot; tier of credit, which is usually defined as a FICO Score above 750.</p>
                <p>With a better knowledge of credit score factors, you can put a credit repair plan in place and track your progress.</p>
                <h2 id="strategies-for-rebuilding-credit">Strategies for Rebuilding Credit</h2>
                <h3>Give yourself some credit</h3>
                <p>Although there&rsquo;s no magic formula for credit repair, there are some tried and true tactics you could (and should!) try when embarking on do-it-yourself credit repair.</p>
                <h3>Tackle credit blemishes head on</h3>
                <p>If you have past due accounts on your credit reports, you want to get them changed to &quot;current&quot; or &quot;paid&quot; status.</p>
                <p>
                    <strong>Work directly with creditors.</strong>
                    {' '}
                    Call them directly to figure out what you can do to get your account in good standing if you&rsquo;re past due.
                </p>
                <p>Be prepared to offer a lump sum, or work out a payment plan if you can.</p>
                <p>
                    <strong>Improve utilization.</strong>
                    {' '}
                    There are two ways to do that: Pay down your balances or increase your credit limits.
                </p>
                <p>
                    If you have access to
                    {' '}
                    <a href="https://www.catrkr.com/rd/r.php?sid=864&pub=221062&c1=credit-repair&c2=savings" rel="noopener noreferrer" target="_blank">savings</a>
                    {' '}
                    or can borrow money from family, reducing your debt can give your credit score a quick boost.
                </p>
                <p>If your credit is poor, your creditors probably won&rsquo;t want to extend even more credit to you.</p>
                <p>But if you&rsquo;re in the &quot;Fair&quot; or &quot;Good&quot; range, it&rsquo;s worth a shot to ask for a credit limit increase.</p>
                <p>Think about it: If you have a $4,000 limit and owe $2,000, that&rsquo;s a 50% utilization rate.</p>
                <p>Bump that up to a $5,000 limit and now your utilization goes down to 40% with very little effort on your part.</p>
                <h3>Prove that you&rsquo;re committed to credit health</h3>
                <p>Remember, your most recent behavior has the biggest impact on your score, so make it count!</p>
                <p>
                    <strong>Always pay on time.</strong>
                    {' '}
                    Set text or email alerts or automate your payments so you don&rsquo;t accidentally miss your due dates.
                </p>
                <p>
                    <strong>Don&rsquo;t open new lines of credit.</strong>
                    {' '}
                    Every inquiry (or credit application) dings your credit score.
                </p>
                <p>In other words, just say no the next time a retail store offers you 15% off if you apply for its card.</p>
                <p>
                    <strong>Get on a budget.</strong>
                    {' '}
                    Credit card debt is often the result of spending beyond your means.
                </p>
                <p>Limit yourself to plastic purchases that you can pay off in full right away.</p>
                <p>
                    <strong>Bulk up an emergency fund.</strong>
                    {' '}
                    If you save money for a rainy day (a few dollars per paycheck can get you started), you won&rsquo;t have to resort to swiping the next time an unexpected expense strikes.
                </p>
                <p>By addressing past mistakes and resolving to become a responsible credit user, it&rsquo;s only a matter of time before your positive behavior pays off in the form of a better credit standing.</p>
                <h2 id="credit-repair-companies">Credit Repair Companies</h2>
                <h3>For big credit problems, turn to the credit repair pros</h3>
                <p>In most cases, you can go the DIY route to repair your own credit so it doesn&rsquo;t cost you anything.</p>
                <p>But if you don&rsquo;t have the time to dedicate, or if problems are complex, professional credit repair services can help.</p>
                <p>Here&rsquo;s when you might benefit from credit repair services:</p>
                <p>
                    <strong>If you&rsquo;re an ID theft victim, it can be overwhelming.</strong>
                    {' '}
                    In a nightmare scenario in which there are several maxed out accounts in your name that don&rsquo;t belong to you, it could be exhausting trying to get everything resolved.
                </p>
                <p>
                    <strong>Pros can help you speed up the credit repair process.</strong>
                    {' '}
                    While no company can guarantee fast results, if you tend to put things off because you lack the time, outsourcing to a professional can fast track your progress.
                </p>
                <p>
                    <strong>You might need a hand for complex items on your credit reports.</strong>
                    {' '}
                    For instance, sometimes the same collection account is sold to different debt collectors, but it appears on your credit report more than once as if they were different debts.
                </p>
                <p>Or, maybe you can&rsquo;t seem to get old medical billing errors removed.</p>
                <p>Getting the right people on the phone can be difficult. In these cases, a credit repair specialist can help.</p>
                <p>
                    <strong>Don&rsquo;t confuse rapid re-scoring with credit repair.</strong>
                    {' '}
                    This is a process initiated by a mortgage lender for people who need a quick credit score improvement, in order to qualify for and lock in a home loan rate.
                </p>
                <p>Basically, you&rsquo;re saying to the lender, my credit score would improve by X once the agency sees this proof I have verifying that some blemish on my current credit report is inaccurate.</p>
                <p>The lender—for a fee—will take that proof as positive evidence your score will improve and communicates as much to the credit agencies.</p>
                <p>If all goes well, your score could improve in as little as 72 hours.</p>
                <p>This is super helpful if time is of the essence because instead of waiting for the typical reporting cycle, which would be 30 days, you can get a better score and qualify for a mortgage rate for the home you want in only days.</p>
                <p>The cost of rapid re-scoring depends on the lender.</p>
                <p>Some lenders will lump in the cost with the loan they provide you.</p>
                <p>Others will ask you to pay for it upfront.</p>
                <p>You should talk with the loan officer in detail, if interested.</p>
                <p>Whatever you do, don&rsquo;t fall prey to organizations claiming that they can do rapid rescoring for you. They can&rsquo;t.</p>
                <p>Only the company giving you the mortgage, for example, can do this, provided you have the proof they need to feel secure your credit score will rise.</p>
                <h3>Separating the scammers from the legit service providers</h3>
                <p>Predatory companies prey on people who are desperate.</p>
                <p>That&rsquo;s why it&rsquo;s important to do your research before working with a credit repair business.</p>
                <p>
                    <strong>Look for &quot;too good to be true&quot; red flags.</strong>
                    {' '}
                    A reputable credit repair company will not promise results along the lines of a 200-point credit score increase.
                </p>
                <p><LazyLoadImage alt="Survey Result: What is a Good Credit Score" src="/media/survey-result-what-is-a-good-credit-score-4.png" /></p>
                <p>
                    <strong>Consider working with a nonprofit credit counseling agency.</strong>
                    {' '}
                    Professionals that are members of the National Foundation for Credit Counseling can provide you with free advice to help you decide if fee-based credit repair help is right for you.
                </p>
                <p>
                    <strong>Google prospective credit repair companies.</strong>
                    {' '}
                    Check the Better Business Bureau and poke around to see if any complaints have been filed before you move forward with a company.
                </p>
                <p>
                    <strong>Run away from businesses that want up-front payments.</strong>
                    {' '}
                    The Credit Repair Organization Act (CROA) clearly states that it is illegal for credit repair businesses to ask for payment before service is rendered.
                </p>
                <p>
                    <strong>Understand that there are costs involved.</strong>
                    {' '}
                    Credit repair service costs will depend on the level of intervention needed and vary company to company
                </p>
                <p>Deciding to work with a credit repair service is a personal decision.</p>
                <p>It is an investment (amounts vary), but it could be worth it to you if you&rsquo;re in over your head with credit confusion.</p>
                <p>If it&rsquo;s just a matter of making minor repairs, you may be better off doing it on your own.</p>
                <h3>The path to financial freedom begins with credit repair</h3>
                <p>Having strong credit is important, and although it might take more work for some than others, it&rsquo;s an attainable goal for anyone.</p>
                <p>Even small score improvements can make a big difference in your life.</p>
                <p>As you move through the &quot;Good,&quot; &quot;Very Good,&quot; and &quot;Excellent&quot; tiers of credit, you&rsquo;ll gain access to bigger and better financial opportunities.</p>
                <p>Credit repair can be the start of big changes in your credit life.</p>
                <p>Set aside some time to fix errors, make amends for past mistakes, and clear up credit report question marks.</p>
                <p>If the process is overwhelming, a credit counselor or credit repair company can help.</p>
                <p>Or, for prospective home buyers, your lender might be able to help you get a rapid rescore.</p>
                <p>Once everything is accurate and up to date, you can focus on fixing your finances, saving money, and using credit wisely—and watch your score soar to new heights!</p>
                <p>Have you ever tried credit repair?</p>
                <p>What worked, and what didn&rsquo;t?</p>
                <p>Any strategies or lessons learned to share with the rest of us?</p>
                <p>Let us know in the comments below.</p>
            </>
        ),
    };

    return (
        <Post article={article} />
    );
};

export default CreditRepairPage;
